// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    convertDateOnlyStringToDate,
    convertDateToDateOnlyString,
} from "@insite/client-framework/Common/Utilities/DateUtilities";
import translate from "@insite/client-framework/Translate";
import DatePicker from "@insite/mobius/DatePicker";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/UpdateDraftParameter";
import { useShipmentHistoryState } from "@store/Framework/Store/Greif/Pages/ShipmentHistory/ShipmentHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { DatePickerPresentationProps } from "@store/MobiusOverrides/DatePicker/DatePicker";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC } from "react";

export interface ShipmentHistoryFilterFieldOrderDatesProps {}

export interface ShipmentHistoryFilterFieldOrderDatesStyles {
    datePicker?: DatePickerPresentationProps;
    fieldWrapper?: InjectableCss;
}

export const shipmentHistoryFilterFieldOrderDatesStyles: ShipmentHistoryFilterFieldOrderDatesStyles = {
    fieldWrapper: filterDrawerProps.fieldWrapper,
    datePicker: { labelProps: filterDrawerProps.subLabel },
};

const styles = shipmentHistoryFilterFieldOrderDatesStyles;

const ShipmentHistoryFilterFieldOrderDates: FC<ShipmentHistoryFilterFieldOrderDatesProps> = () => {
    const dispatch = useAppDispatch();
    const { fromDate: draftFromDate, toDate: draftToDate } = useShipmentHistoryState().draftParameter;

    const fromDate = convertDateOnlyStringToDate(draftFromDate);
    const toDate = convertDateOnlyStringToDate(draftToDate);

    return (
        <FilterDrawerSection title={translate("Order Dates")} isAccordion={true}>
            <StyledWrapper {...styles.fieldWrapper} data-test-selector="shipmentHistory_filterFromDate">
                <DatePicker
                    {...styles.datePicker}
                    data-test-selector="shipmentHistory_filterFromDatePicker"
                    label={translate("Order Date From")}
                    selectedDay={fromDate}
                    onDayChange={({ selectedDay }) =>
                        dispatch(updateDraftParameter({ fromDate: convertDateToDateOnlyString(selectedDay) }))
                    }
                    dateTimePickerProps={{
                        maxDate: toDate,
                        ...styles.datePicker?.dateTimePickerProps,
                    }}
                />
            </StyledWrapper>
            <StyledWrapper {...styles.fieldWrapper} data-test-selector="shipmentHistory_filterToDate">
                <DatePicker
                    {...styles.datePicker}
                    data-test-selector="shipmentHistory_filterToDatePicker"
                    label={translate("Order Date To")}
                    selectedDay={toDate}
                    onDayChange={({ selectedDay }) =>
                        dispatch(updateDraftParameter({ toDate: convertDateToDateOnlyString(selectedDay) }))
                    }
                    dateTimePickerProps={{
                        minDate: fromDate,
                        ...styles.datePicker?.dateTimePickerProps,
                    }}
                />
            </StyledWrapper>
        </FilterDrawerSection>
    );
};

export default ShipmentHistoryFilterFieldOrderDates;
